// Paid requests must retain their key beyond the short publication UI session.
// An unknown charge never expires into a fresh paid operation on reload.
const PREFIX='cloudpush_generation_intent:';
const memory=new Map<string,string>();
export function generationIntent(scope:string):string {
 let key:string|null=null;
 try{key=localStorage.getItem(PREFIX+scope);}catch{/* retain within this page when browser storage is unavailable */}
 if(key && /^[A-Za-z0-9._:-]{1,190}$/.test(key))return key;
 if(memory.has(scope))return memory.get(scope)!;
 key='cp-'+crypto.randomUUID();memory.set(scope,key);
 try{localStorage.setItem(PREFIX+scope,key);}catch{/* the UI still repeats the same key within this page */}
 return key;
}
export function finishGenerationIntent(scope:string){memory.delete(scope);try{localStorage.removeItem(PREFIX+scope);}catch{/* no credentials or output is stored */}}
